/* eslint-disable @typescript-eslint/ban-types */

import * as Sentry from '@sentry/browser';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressBar } from '../components/ProgressBar';
import { AbandonButton } from '../components/AbandonButton';
import { CommonStepButtons } from '../components/CommonStepButtons';
import { QuestionWrapper } from '../components/QuestionWrapper';
import { Rating1to5 } from '../components/Rating1to5';
import { OuterScreenWrapper, ScreenWrapper } from '../components/ScreenWrapper';
import { IntakeFormProps } from '../models/intakeForm';
import { getQuestionDataFor } from '../selectors/intakeFormSelectors';

export const IntakeNumericalResponseScreen: React.FC<IntakeFormProps> = ({
    currentScreen,
    responses,
    screenCount,
    onAbandonClick,
    skipQuestion,
    saveMultipleResponses,
    goBack,
}) => {
    const { questionText, questionIds, screenIndex } = getQuestionDataFor(currentScreen);
    const [responseObj, setResponseObj] = useState(responses || {});
    const { t } = useTranslation();

    const submitResponse = () => {
        saveMultipleResponses(responseObj as object);
    };

    const handleAbandonClick = () => {
        onAbandonClick(responseObj);
    };

    const handleSubQuestionResponse = (id: string, value: number) => {
        setResponseObj({
            ...(responseObj as object),
            [id]: value,
        });
    };

    if (!questionIds) {
        Sentry.captureException(
            new Error(
                'Received malformed or empty question data for multiple rating question screen',
            ),
        );
        skipQuestion();
        return null;
    }

    return (
        <OuterScreenWrapper>
            <ScreenWrapper>
                <ProgressBar progress={screenIndex / screenCount} />
                <AbandonButton onClick={handleAbandonClick} />
                <QuestionWrapper title={t(questionText)} scrollContent>
                    <form onSubmit={submitResponse}>
                        {questionIds.map(
                            ({ subQuestionId, subQuestionSubtitle, subQuestionTitle }) => (
                                <Rating1to5
                                    key={subQuestionId}
                                    title={subQuestionTitle}
                                    subtitle={subQuestionSubtitle}
                                    ratingId={subQuestionId}
                                    lastRating={responseObj[subQuestionId]}
                                    onSelect={handleSubQuestionResponse}
                                />
                            ),
                        )}
                        <CommonStepButtons onForwardClick={submitResponse} onBackClick={goBack} />
                    </form>
                </QuestionWrapper>
            </ScreenWrapper>
        </OuterScreenWrapper>
    );
};
